import React from 'react';
import classNames from 'classnames';

import { BlockHeader } from 'components/blocks/BlockHeader';
import { BlockContent } from 'components/blocks/BlockContent';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';

import { useOTSTranslation } from 'i18n/useOTSTranslation';
import commonStyles from 'page-components/resort/skireport.module.scss';

import type { INews } from 'api/home/types';
import NewsItem from 'components/resort/SurfaceRelatedArticles/components/NewsItem';
import { getPortalOptions } from 'util/getPortalConfig';

import styles from './styles.module.scss';

interface ISurfaceRelatedArticles {
  relatedNewsList: Array<INews> | null,
  isFresh?: boolean,
  isSummerMode?: boolean,
}

const SurfaceRelatedArticles = ({ relatedNewsList, isFresh, isSummerMode }: ISurfaceRelatedArticles) => {
  const { t } = useOTSTranslation('common');

  const { hasNews } = getPortalOptions();
  if (!hasNews || !relatedNewsList || !relatedNewsList.length) {
    return null;
  }

  return (
    <BoxWithShadow className={classNames(styles.wrapper)}>
      <BlockHeader title={t('common.relatedNews')} className={isSummerMode ? styles.greenTitle : undefined} />
      <BlockContent
        blur={!isFresh}
        className={commonStyles.seoText}
      >
        {relatedNewsList.map((item) => (
          <NewsItem
            key={item.uuid}
            topic={item.title}
            href={item.link!}
            imgSrc={item.thumbnail || item.image}
            description={item.description}
          />
        ))}
      </BlockContent>
    </BoxWithShadow>
  );
};

export default SurfaceRelatedArticles;
